export const SLICE_TAG = {
    BRANDS: 'Brands',
    CATEGORY: 'Category',
    UNIT: 'Unit',
    GENETIC: 'Genetic',
    STRENGTH: 'Strength',
    TYPE: 'Type',
    PRODUCTS: 'Products',
    PRODUCTS_V2: 'Products_V2',

    ROLES: 'Roles',
    ROLES_PERMISSIONS: 'Roles_Permissions',
    USERS: 'Users',

    CART_SALE: 'Cart_Sale',

    INVENTORY_STOCK: 'Inventory_Stock',
    INVENTORY_STOCKS: 'Inventory_Stocks',
    INVENTORY_SALE: 'Inventory_Sale',
    INVENTORY_LOW_STOCK: 'Inventory_Low_Stock',
    INVENTORY_EXPIRED: 'Inventory_Expired',
    INVENTORY_STOCK_OUT: 'Inventory_Stock_Out',
    INVENTORY_BATCHES: 'Inventory_Batches',

    INVENTORY_ADJUSTMENTS: 'Inventory_Adjustments',

    PURCHASES: 'Purchases',
    PRE_PURCHASES: 'Pre_Purchases',
    CART_CLEAR: 'Cart_Clear',
    CUSTOMERS: 'Customers',
    AUTH_USER: 'Auth_User',

    SALES: 'SALES',

    EXPENSE: 'Expense',
    EXPENSE_CATEGORY: 'Expense-Category',
    TRANSACTION: 'Transaction',
    BALANCE_SHEET: 'Balance-Sheet',
    SUPPLIERS: 'Suppliers',
    SETTINGS: 'Settings',
    WHOLESALE_ADMIN_REQUESTS: 'Wholesale-Admin-Requests',
    WHOLESALE_ADMIN_CUSTOMERS: 'Wholesale-Admin-Customers',

    // Sales Return
    SALES_RETURN: 'Sales_Return',

    // Notifications
    NOTIFICATIONS: 'Notifications',

    // Reports
    PROFIT_LOSS_REPORT: 'Profit_Loss_Report',
    EXPENSE_REPORT: 'Expense_Report',
    BALANCE_HISTORY: 'Balance_History',

    // Purchase Return
    PURCHASE_RETURN: 'Purchase_Return',
};
